export default __webpack_public_path__ + "static/media/479.79fd9299.png";